const Global = () => {}
export default Global;

Global.HOST = "https://senseadmin.spinlock.co.uk";
Global.SNURL = "https://senseadmin.spinlock.co.uk/firmware/rigsense";
Global.SNFILE = "snfirmware.txt";
Global.HOSTSUCCESS = "https://sense.spinlock.co.uk";
Global.SUCCESS = "https://sense.spinlock.co.uk/log?";
Global.WFileName = null;
Global.WVersion = null;
Global.WFDesc = null;
Global.softwareVersion = "N/A";

Global.myESP32 = 'aedb84c7-ff8b-4996-bfc6-fd14791851bb';
Global.otaServiceUuid = 'd6f1d96d-594c-4c53-b1c6-144a1dfde6d8';
Global.otaDataCharacteristicUuid = '23408888-1f40-4cd8-9b89-ca8d45f8a5b0';
Global.otaContCharacteristicUuid = '7ad671aa-21c0-46a4-b722-270e3ae3d830';
Global.esp32Device = null;
Global.esp32Service = null;
Global.espOTAService = null;
Global.versionCharacteristicUuid = '7453d3f1-ee00-4761-b34b-bf8bc58152d2';
Global.DVersion = null;
Global.OlderVersion = false;
Global.updateData = null;
Global.updateDataLength = 0;

Global.totalSize = 0;
Global.remaining = 0;
Global.amountToWrite = 0;
Global.currentPosition = 0;
Global.dataToSend = null;

Global.characteristicSizeArray = new Uint8Array([0xFD,0x00]);
Global.characteristicSize = 253;
Global.DVersion = null;
Global.SVR_CHR_OTA_CONTROL_REQUEST = new Uint8Array([0x01]);
Global.SVR_CHR_OTA_CONTROL_DONE = new Uint8Array([0x04]);


